"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
var contextos_frontend_1 = require("@aura/contextos-frontend");
var temas_frontend_1 = require("@aura/temas-frontend");
var react_1 = __importDefault(require("react"));
var paragraphy_styles_1 = require("../../token/paragraphy/paragraphy.styles");
var tags_ga_1 = require("../../utils/tags-ga");
var styles_1 = require("./styles");
var Radio = function (_a) {
    var id = _a.id, label = _a.label, value = _a.value, onChange = _a.onChange, gaCategory = _a.gaCategory, gaAction = _a.gaAction, gaLabel = _a.gaLabel, gaEventType = _a.gaEventType, name = _a.name, disabled = _a.disabled, checked = _a.checked, inputProps = _a.inputProps, hasError = _a.hasError, errorMessage = _a.errorMessage;
    var theme = (0, temas_frontend_1.useTheme)().theme;
    var isEnabled = (0, contextos_frontend_1.useToggles)().isEnabled;
    var ACESSIBILIDADE_ALTO_CONTRASTE = 'SAVA_165614';
    return (react_1.default.createElement(styles_1.RadioSectionStyled, null,
        react_1.default.createElement(styles_1.RadioLabelStyled, { htmlFor: id, disabled: disabled },
            label,
            react_1.default.createElement(tags_ga_1.TagsGa, { category: gaCategory, action: gaAction, label: gaLabel, eventType: gaEventType },
                react_1.default.createElement(styles_1.RadioInputStyled, __assign({ id: id, type: "radio", role: "radio", name: name, value: value, disabled: disabled, onChange: onChange, checked: checked }, inputProps))),
            react_1.default.createElement(styles_1.RadioBulletStyled, { altoContrasteAtivo: isEnabled(ACESSIBILIDADE_ALTO_CONTRASTE) })),
        hasError && errorMessage && (react_1.default.createElement(paragraphy_styles_1.PStyled, { small: true, color: theme.error, style: { marginTop: '8px', marginLeft: '24px', marginBottom: "".concat(hasError ? '16px' : '0') } }, errorMessage))));
};
exports.Radio = Radio;
